import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneTopDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"phone-top-dynamic-island"} maskId="square-filled-radius-0-stroke-1-IconPhoneTopDynamicIsland"><path fillRule="evenodd" clipRule="evenodd" d="M17 3C19.2091 3 21 4.79086 21 7V21H3V7C3 4.79086 4.79086 3 7 3H17ZM11 5C10.5858 5 10.25 5.33579 10.25 5.75C10.25 6.16421 10.5858 6.5 11 6.5H13C13.4142 6.5 13.75 6.16421 13.75 5.75C13.75 5.33579 13.4142 5 13 5H11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPhoneTopDynamicIsland;
